// src/LocaleProvider.jsx
import React, { useEffect, useState } from 'react';
import { ConfigProvider } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'utils/dayjsConfig';

const antdLocaleLoaders = {
  en: () => import(/* webpackChunkName: "antd-locale-en" */ 'antd/es/locale/en_US'),
  es: () => import(/* webpackChunkName: "antd-locale-es" */ 'antd/es/locale/es_ES'),
};

const resolveBaseLocale = (language = 'en') => {
  if (language === 'en_proman') return 'en';
  return language.split(/[-_]/)[0];
};

export default function LocaleProvider({ children }) {
  const { i18n } = useTranslation();
  // It will split on either - or _, whichever is found first in the string.
  // "es-ES" becomes "es"; "en_proman" explicitly uses English component locales.
  const lang = resolveBaseLocale(i18n.language);

  const [antdLocale, setAntdLocale] = useState(undefined);

  useEffect(() => {
    const loader = antdLocaleLoaders[lang] || antdLocaleLoaders.en;
    loader().then((mod) => setAntdLocale(mod.default));
  }, [lang]);

  const customTheme = {
    token: {
      colorPrimary: '#2a97ff',
      colorPrimaryHover: '#1777ff',
      fontFamily: "'Be Vietnam', sans-serif",
    },
    components: {
      Button: {
        colorPrimaryHover: '#1777ff',
      },
      Spin: {
        colorPrimary: '#2a97ff',
      },
    },
  };

  // push locale into dayjs
  useEffect(() => {
    dayjs.locale(lang);
  }, [lang]);

  return (
    <ConfigProvider locale={antdLocale} theme={customTheme}>
      {children}
    </ConfigProvider>
  );
}